import { useCategoryMenuStore, useLayoutsStore } from "~/stores/extensionApi";
import { useCategoryStore } from "~/modules/catalog/category/stores/category";
import { useCustomAttributeMetadata } from "~/stores/customAttributeMetadata";

export default async function ({ store }) {
  const categoryMenuStore = useCategoryMenuStore();
  const categories = useCategoryStore();
  const customAttributeMetadataStore = useCustomAttributeMetadata();
  const layoutsStore = useLayoutsStore();

    await categoryMenuStore.loadNewMenuMega();
    await categoryMenuStore.loadNewMenuMegaMobile();
    await layoutsStore.loadLayouts();
    await categories.load();
    await customAttributeMetadataStore.loadCustomAttributeMetadata();



}
